var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"lightbox",on:{"click":function($event){return _vm.$emit('input', null)}}},[_c('img',{attrs:{"src":_vm.value.image}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }